<div class="sv-question-property-typology">
  <div
    class="nd-select nd-select--chip"
    [class.is-open]="isOpen"
    [class.has-selected]="hasSelected"
    [class.is-disabled]="model.isReadOnly">
    <!-- Controllo chip / Trigger -->
    <div
      class="nd-select__control cy-typologyFilter"
      role="button"
      tabindex="0"
      [attr.aria-expanded]="isOpen"
      [attr.aria-disabled]="model.isReadOnly"
      (click)="toggleDropdown($event)"
      (keydown.enter)="toggleDropdown($event)"
      (keydown.space)="toggleDropdown($event)">
      <!-- Valore visualizzato -->
      <div class="nd-select__value">{{ controlText }}</div>

      <!-- Freccia / Chevron -->
      <svg
        viewBox="0 0 24 24"
        class="nd-icon nd-select__arrow"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </div>

    <!-- Dropdown menu -->
    <div
      *ngIf="isOpen"
      class="nd-select__menu nd-dropdown is-open"
      data-cy="typology-dropdown"
      (click)="$event.stopPropagation()">
      <div>
        <div
          class="nd-accordion nd-accordion--unstyled nd-dropdown__contentScrollable">
          <div
            *ngFor="let group of groups"
            class="nd-accordion__item"
            [class.is-open]="isExpanded(group)"
            [class.no-content]="!hasContent(group)"
            [class.is-selected]="isGroupSelected(group)"
            data-cy="multiselectListItem">
            <!-- Titolo gruppo (radio) -->
            <div
              class="nd-accordion__title"
              [class.is-selected]="isGroupSelected(group)"
              [attr.tabindex]="hasContent(group) ? 0 : null"
              [attr.role]="hasContent(group) ? 'button' : null"
              [attr.aria-expanded]="
                hasContent(group) ? isExpanded(group) : null
              "
              (click)="onGroupTitleClick(group, $event)"
              (keydown.enter)="onGroupTitleClick(group, $event)">
              <div
                class="AccordionLabelContent_content cy-accordionItem"
                role="button"
                tabindex="0"
                (click)="toggleGroup(group, $event)">
                <label class="nd-radio" (click)="toggleGroup(group, $event)">
                  <input
                    class="nd-radio__element"
                    type="radio"
                    readonly
                    [attr.aria-checked]="isGroupSelected(group)"
                    [checked]="isGroupSelected(group)" />
                  <span class="nd-radio__text">{{ group.label }}</span>
                </label>
              </div>

              <svg
                *ngIf="hasContent(group)"
                viewBox="0 0 24 24"
                class="nd-icon nd-accordion__icon"
                (click)="onGroupChevronClick(group, $event)">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>

            <!-- Contenuto gruppo (checkbox) -->
            <div
              *ngIf="hasContent(group) && isExpanded(group)"
              class="nd-accordion__content">
              <div>
                <ul class="nd-stack">
                  <li class="nd-stackItem ListItem_item">
                    <label
                      class="nd-checkbox List_checkbox"
                      (click)="toggleGroup(group, $event)">
                      <input
                        class="nd-checkbox__element"
                        type="checkbox"
                        readonly
                        [attr.aria-checked]="isGroupSelected(group)"
                        [checked]="isGroupSelected(group)" />
                      <span class="nd-checkbox__text">
                        {{ model.selectAllText || 'Tutte le tipologie' }}
                      </span>
                    </label>
                  </li>

                  <li
                    *ngFor="let item of group.items"
                    class="nd-stackItem ListItem_item">
                    <label
                      class="nd-checkbox List_checkbox"
                      (click)="toggleItem(item.value, $event)">
                      <input
                        class="nd-checkbox__element"
                        type="checkbox"
                        readonly
                        [attr.aria-checked]="isItemSelected(item.value)"
                        [checked]="isItemSelected(item.value)" />
                      <span class="nd-checkbox__text">{{ item.text }}</span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer con pulsante di conferma -->
      <div class="nd-select__footer" *ngIf="model.confirmText">
        <span role="button" tabindex="0">
          <button
            type="button"
            class="nd-button nd-button--accent nd-button--block"
            data-cy="search-button"
            (click)="onConfirm()">
            {{ model.confirmText }}
          </button>
        </span>
      </div>
    </div>
  </div>
</div>
